// extracted by mini-css-extract-plugin
export default {"skipButton":"skip-to-content-skipButton-ij2oE2"};